const getters = {
  tag: (state) => state.tags.tag,
  website: (state) => state.common.website,
  userInfo: (state) => state.user.userInfo,
  theme: (state) => state.common.theme,
  themeName: (state) => state.common.themeName,
  isShade: (state) => state.common.isShade,
  isCollapse: (state) => state.common.isCollapse,
  keyCollapse: (state, getters) =>
    getters.screen > 1 ? getters.isCollapse : false,
  screen: (state) => state.common.screen,
  isLock: (state) => state.common.isLock,
  isFullScreen: (state) => state.common.isFullScreen,
  lockPasswd: (state) => state.common.lockPasswd,
  tagList: (state) => state.tags.tagList,
  tagWel: (state) => state.tags.tagWel,
  access_token: (state) => state.user.access_token,
  refresh_token: (state) => state.user.refresh_token,
  roles: (state) => state.user.roles,
  permissions: (state) => state.user.permissions,
  menu: (state) => state.user.menu,
  menuAll: (state) => state.user.menuAll,
  logsList: (state) => state.logs.logsList,
  logsLen: (state) => state.logs.logsList.length || 0,
  logsFlag: (state, getters) => getters.logsLen === 0,
  currentMenuId: (state) => state.common.currentMenuId,
  viewData: state => state.monitoringWork.viewData,
  viewDataLabel: state => state.monitoringWork.viewDataLabel,
  statusNumList: state => state.monitoringWork.statusNumList,
  curveAnalysisList:state => state.curveAnalysis.curveAnalysisList,
  curveAnalysisSelectParams:state => state.curveAnalysis.curveAnalysisSelectParams,
  // 鳄币商城列表 值
  eCoinMallTableData:state => state.eCoinMall.eCoinMallTableData,
  // 套餐当前编辑商品的id
  goodSpecCurrentEditId:state => state.goodSpecStores.goodSpecCurrentEditId,
  // 当前id下套餐所有的固定规格
  goodSpecCurrentSpecFixed:state => state.goodSpecStores.goodSpecCurrentSpecFixed,
  // 当前id下套餐所有的可选规格
  goodSpecCurrentSpecUnFixed:state => state.goodSpecStores.goodSpecCurrentSpecUnFixed,
  // tableLoading - 固定规格
  fixedTableLoading:state => state.goodSpecStores.fixedTableLoading,
  // tableLoading - 可选规格
  unFixedTableLoading:state => state.goodSpecStores.unFixedTableLoading,
  // 套餐当前编辑商品的名称
  goodSpecCurrentEditName:state => state.goodSpecStores.goodSpecCurrentEditName,
  // 当前编辑的广告类型
  currentEditAdsenseType:state => state.goodSpecStores.currentEditAdsenseType,
  // 当前编辑的广告id
  currentEditAdsenseId:state => state.goodSpecStores.currentEditAdsenseId,
  // 当前编辑店铺的组网模式
  // 是机器直连
  siteIsMacDirect:state => state.siteStore.currentEditSiteNetworkMode === 'MACHINE_DIRECT'?true:false,
  // 是店铺中转
  siteIsSiteDirect:state => state.siteStore.currentEditSiteNetworkMode === 'SITE_DIRECT'?true:false,
  // 只取第一位的macId
  firstMacInstanceId: state => {
        const macs = state.siteStore.currentEditSiteObj.macs
        // 保险点写法：判断macs存在、是数组、长度大于0、且mac对象存在
        return Array.isArray(macs) && macs.length > 0 && macs[0].mac
          ? macs[0].mac.macInstanceId
          : undefined
      },
  currentEditSiteMacObj:state => state.siteStore.currentEditSiteMacObj,
  shopIndentPageLoading:state => state.shopIndent.shopIndentPageLoading,
  shopIndentPageRecords:state => state.shopIndent.shopIndentPageRecords,
  shopIndentPageTotal:state => state.shopIndent.shopIndentPageTotal,
  shopIndentReserveGoodsMenuTypeList:state => state.shopIndent.shopIndentReserveGoodsMenuTypeList,
  shopIndentReserveGoodsSumGoodsData:state => state.shopIndent.shopIndentReserveGoodsSumGoodsData,
  shopIndentDetail:state => state.shopIndent.shopIndentDetail,
  shopIndentReShowDetail:state => state.shopIndent.shopIndentReShowDetail,
};
export default getters;
